import MultiSelect from "components/MultiSelect/MultiSelect";
import FormFieldProps from "components/form/FormFieldProps";
import * as React from "react";
import {HostedInstanceChip, DeletedHostedInstanceChip} from "shared/HostedInstanceChip";
import {HostedInstanceLookupResource} from "client/resources/hostedInstanceLookupResource";
import {SelectItem} from "../components/VirtualListWithKeyboard/SelectItem";
import {themeTokens} from "@octopusdeploy/design-system-tokens";
import {css} from "@emotion/css";

interface HostedInstanceMultiSelectProps extends FormFieldProps<string[]> {
    items: HostedInstanceLookupResource[];
    autoFocus?: boolean;
    label?: string | JSX.Element;
    error?: string;
}

interface InstanceSelectItem extends HostedInstanceLookupResource {
    Name: string;
}

const HostedInstanceTypedMultiSelect = MultiSelect<InstanceSelectItem>();

const HostedInstanceMultiSelect: React.FC<HostedInstanceMultiSelectProps> = props => {
    const chipRenderer = (i: InstanceSelectItem | SelectItem, onRequestDelete: (event: object) => void) => {
        if ("ShortId" in i) {
            return <HostedInstanceChip instance={i} onRequestDelete={onRequestDelete}/>;
        }
        return <DeletedHostedInstanceChip instanceId={i.Id} onRequestDelete={onRequestDelete}/>;
    };
    const items = props.items.map(i => ({...i, Name: `${i.DnsPrefix} (${i.ShortId })`}));
    const secondaryTextStyle = css`color: ${themeTokens.color.text.tertiary}`;
    return <HostedInstanceTypedMultiSelect
        {...props}
        renderItem={(i: InstanceSelectItem) => (
            {
                primaryText: i.DnsPrefix,
                secondaryText: <div className={secondaryTextStyle}>{i.ShortId}<br/>{i.Status}</div>
            })}
        fieldName="hosted instance"
        renderChip={chipRenderer}
        items={items}/>;
};

export default HostedInstanceMultiSelect;
